import React, { useRef, useState, useEffect } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import IdleTimer from "react-idle-timer";

import AppLayout from "./components/AppLayout";
import { Login } from "./components/Authentication/Login";
import { LockScreen } from "./components/Authentication/LockScreen";
import RequestResetPassword from "./components/Authentication/RequestResetPassword";
import ResetPassword from "./components/Authentication/ResetPassword";
import { Session, User_Preferences } from "./business";
import "./App.css";

import { LoginUserPortal } from "./components/Authentication/PortalLogin";
import RegisterUniCV from "./components/Authentication/Register/RegisterUnicv";
import { sendHttpRequest } from "./components/http.request";

const App = () => {
    let idleTimer = useRef();

    const [isTimedOut, setIsTimedOut] = useState(false);

    let user = Session.getUsername();

    const history = useHistory();

    const hash = window.location?.hash?.replace("#", "");

    const isPortal = Session.getUsername() === "_portal_";

    useEffect(() => {
        const isLocked = Session.isLockedScreen();

        if (isLocked && user && !isPortal) {
            if (idleTimer.current) {
                idleTimer.reset();
            }
            setIsTimedOut(true);
        }
    }, [isPortal, user]);

    if (
        !user &&
        !hash.startsWith(`/login`) &&
        !hash.includes("reset-password") &&
        !hash.includes("portal") &&
        !hash.includes("register/")
    ) {
        history.replace("/login?redirect=" + hash);
    }

    const logout = async () => {
        const formData = new FormData();
        formData.append("accao", "logout");

        await sendHttpRequest("POST", "/Gestor/gereutilizador.php", formData);
    };

    const handleOnIdle = async (event) => {
        if (!isTimedOut) {
            idleTimer.reset();
            setIsTimedOut(true);
            Session.lockScreen();

            console.log("Idle, lock screen, closse session");
            logout();
        }
    };

    const unlocked = () => {
        idleTimer.reset();
        setIsTimedOut(false);
        Session.unlockScreen();
    };

    const time_to_look_screen = Number(User_Preferences.getTimeToLookScreen() || 300000);

    return (
        <div id="layout">
            <Switch>
                {!user ? (
                    <>
                        <Route path="/portal" component={LoginUserPortal} />
                        <Route path="/login" component={Login} />
                        <Route path="/register/unicv" exact component={RegisterUniCV} />
                        <Route path="/request-reset-password" exact component={RequestResetPassword} />
                        <Route path="/reset-password/:user/:token" exact component={ResetPassword} />
                    </>
                ) : (
                    <>
                        <IdleTimer
                            ref={(ref) => {
                                idleTimer = ref;
                            }}
                            timeout={process.env.NODE_ENV === "development" ? 30 * 60 * 1000 : time_to_look_screen}
                            onIdle={handleOnIdle}
                            debounce={250}
                        />
                        <div style={{ display: isTimedOut ? "none" : "block" }}>
                            <AppLayout history={history} />
                        </div>

                        {isTimedOut && <LockScreen unlocked={unlocked} />}
                    </>
                )}
            </Switch>
        </div>
    );
};

// eslint-disable-next-line no-extend-native
String.prototype.toPascalCase = function (space = false) {
    return this.match(/[a-z]+/gi)
        ?.map(function (word) {
            return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
        })
        .join(space ? " " : "");
};

// eslint-disable-next-line no-extend-native
String.prototype.toQAFormValue = function () {
    switch (this.trim()) {
        case "true":
            return "t";
        case "false":
            return "f";
        default:
            return this.trim();
    }
};

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

export default App;
